export default __webpack_public_path__ + "media/images/mailer-new/common/logo-header-456c8d2282e1ace54ff5fe8c564d66b5.png";